import { defineMessages } from 'react-intl';

const messages = defineMessages({
  active: {
    id: 'App.BlueMoonActivePropertiesNote.Active',
    defaultMessage: 'Blue Moon active',
  },
  propertyLabel: {
    id: 'App.BlueMoonActivePropertiesNote.PropertyLabel',
    defaultMessage: '{name} · Blue Moon active',
  },
  fallback: {
    id: 'App.BlueMoonActivePropertiesNote.Fallback',
    defaultMessage:
      // eslint-disable-next-line max-len
      'New leases use Blue Moon. The assigned Fortress centralized lease is kept as a fallback if Blue Moon is turned off.',
  },
  forbidden: {
    id: 'App.BlueMoonActivePropertiesNote.Forbidden',
    defaultMessage: "Blue Moon status isn't available with your access.",
  },
  loading: {
    id: 'App.BlueMoonActivePropertiesNote.Loading',
    defaultMessage: 'Checking which properties use Blue Moon.',
  },
  unavailable: {
    id: 'App.BlueMoonActivePropertiesNote.Unavailable',
    defaultMessage: 'Blue Moon status unavailable right now.',
  },
});

export default messages;
